module.exports = "https://deal-img.imgix.net/consumer/modern/bahamas.07ac1462.jpg";